export const getBaseUrl = () => {
    return location.protocol + '//' + location.hostname;
};